<template>
  <div id="refresh" :style="{ height: heightPX+'px !important'}"  v-if="loading">
    <div class="spinner"></div>
    <!-- <div v-for="(item, index) in 2">
      <div data-v-4d5d9caa="" :style="`transform: translateY(${index * 215}px);`" :data-index="index">
        <div data-v-4d5d9caa="" class="outter-wrap skeleton-wrap">
          <template v-if="edition == 3">
            <div data-v-4d5d9caa="" data-v-3a8f5f1a="" ref="myDiv" class="list">
              <div data-v-3a8f5f1a="" class="version_biaozhun" style="margin-top:0px;">
                <div data-v-3a8f5f1a="" class="item">
                  <div data-v-3a8f5f1a="" class="title">
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_50" style="width: 0.2rem; height: 0.2rem;"></div>
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.4rem; height: 0.1rem;"></div>
                  </div>
                  <div data-v-3a8f5f1a="" class="info" style="width:100%" v-if="stemplate.sportId == 'N1'">
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                  </div>
                  <div data-v-3a8f5f1a="" class="wrap" :style="account.previewFlag ? 'height: 0.4rem !important;':'height: 1rem !important;'">
                    <div data-v-3a8f5f1a="" class="content">
                      <div data-v-3a8f5f1a="" class="content-wrap">
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.20rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                          </div>
                      </div>
                      <div data-v-3a8f5f1a="" class="content-wrap" v-if="!account.previewFlag" >
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                      </div>
                      <div data-v-3a8f5f1a="" class="content-wrap"  v-if="!account.previewFlag" >
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                      </div>
                      <div data-v-3a8f5f1a="" class="content-wrap"  v-if="!account.previewFlag" >
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-3a8f5f1a="" class="item">
                  <div data-v-3a8f5f1a="" class="title">
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_50" style="width: 0.2rem; height: 0.2rem;"></div>
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.4rem; height: 0.1rem;"></div>
                  </div>
                  <div data-v-3a8f5f1a="" class="info" style="width:100%">
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                  </div>
                  <div data-v-3a8f5f1a="" class="wrap" :style="account.previewFlag ? 'height: 0.4rem !important':'height: 1rem !important'">
                    <div data-v-3a8f5f1a="" class="content">
                      <div data-v-3a8f5f1a="" class="content-wrap">
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.20rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                          </div>
                      </div>
                      <div data-v-3a8f5f1a="" class="content-wrap"  v-if="!account.previewFlag" >
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                      </div>
                      <div data-v-3a8f5f1a="" class="content-wrap" v-if="!account.previewFlag" >
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                      </div>
                      <div data-v-3a8f5f1a="" class="content-wrap" v-if="!account.previewFlag" >
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-3a8f5f1a="" class="item">
                  <div data-v-3a8f5f1a="" class="title">
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_50" style="width: 0.2rem; height: 0.2rem;"></div>
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.4rem; height: 0.1rem;"></div>
                  </div>
                  <div data-v-3a8f5f1a="" class="info" style="width:100%">
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                  </div>
                  <div data-v-3a8f5f1a="" class="wrap" :style="account.previewFlag ? 'height: 0.4rem !important':'height: 1rem !important'">
                    <div data-v-3a8f5f1a="" class="content">
                      <div data-v-3a8f5f1a="" class="content-wrap">
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.20rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 1.45rem; height: 0.20rem;"></div>
                          </div>
                      </div>
                      <div data-v-3a8f5f1a="" class="content-wrap"  v-if="!account.previewFlag" >
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                      </div>
                      <div data-v-3a8f5f1a="" class="content-wrap" v-if="!account.previewFlag" >
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                      </div>
                      <div data-v-3a8f5f1a="" class="content-wrap" v-if="!account.previewFlag" >
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.57rem; height: 0.15rem;"></div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="edition == 0">
            <div data-v-3a8f5f1a="" class="list">
              <div data-v-3a8f5f1a="" class="version_biaozhun" :style="stemplate.int_marketToggle!=2?'margin-top:0px;':''">
                <div data-v-3a8f5f1a="" class="item">
                    <div data-v-3a8f5f1a="" class="title">
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_50" style="width: 0.2rem; height: 0.2rem;"></div>
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.4rem; height: 0.1rem;"></div>
                    </div>
                    <div data-v-3a8f5f1a="" class="info">
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 3.19rem; height: 0.1rem;"></div>
                    </div>
                    <div data-v-3a8f5f1a="" class="wrap">
                      <div data-v-3a8f5f1a="" class="left">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.51rem; height: 0.1rem;margin-top: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.51rem; height: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.1rem; height: 0.1rem;"></div>
                      </div>
                      <div data-v-3a8f5f1a="" class="content">
                          <div data-v-3a8f5f1a="" class="content-wrap">
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                            </div>
                          </div>
                      </div>
                    </div>
                </div>
                <div data-v-3a8f5f1a="" class="item">
                    <div data-v-3a8f5f1a="" class="title">
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_50" style="width: 0.2rem; height: 0.2rem;"></div>
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.4rem; height: 0.1rem;"></div>
                    </div>
                    <div data-v-3a8f5f1a="" class="info">
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 3.19rem; height: 0.1rem;"></div>
                    </div>
                    <div data-v-3a8f5f1a="" class="wrap">
                      <div data-v-3a8f5f1a="" class="left">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.51rem; height: 0.1rem;margin-top: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.51rem; height: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.1rem; height: 0.1rem;"></div>
                      </div>
                      <div data-v-3a8f5f1a="" class="content">
                          <div data-v-3a8f5f1a="" class="content-wrap">
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                            </div>
                          </div>
                      </div>
                    </div>
                </div>
                <div data-v-3a8f5f1a="" class="item">
                    <div data-v-3a8f5f1a="" class="title">
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_50" style="width: 0.2rem; height: 0.2rem;"></div>
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.4rem; height: 0.1rem;"></div>
                    </div>
                    <div data-v-3a8f5f1a="" class="info">
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 3.19rem; height: 0.1rem;"></div>
                    </div>
                    <div data-v-3a8f5f1a="" class="wrap">
                      <div data-v-3a8f5f1a="" class="left">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.51rem; height: 0.1rem;margin-top: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.51rem; height: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.1rem; height: 0.1rem;"></div>
                      </div>
                      <div data-v-3a8f5f1a="" class="content">
                          <div data-v-3a8f5f1a="" class="content-wrap">
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                            </div>
                          </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else-if="edition == 2">
            <div data-v-3a8f5f1a="" class="list">
              <div data-v-3a8f5f1a="" class="version_biaozhun" :style="stemplate.int_marketToggle!=2?'margin-top:0px;':''">
                <div data-v-3a8f5f1a="" class="item">
                  <div data-v-3a8f5f1a="" class="title">
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_50" style="width: 0.2rem; height: 0.2rem;"></div>
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.4rem; height: 0.1rem;"></div>
                  </div>
                  <div data-v-3a8f5f1a="" class="info" style="width:100%">
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                  </div>
                  <div data-v-3a8f5f1a="" class="wrap">
                    <div data-v-3a8f5f1a="" class="content" :style="stemplate.sportId!='N1' ? 'width: 100%':''">
                      <div data-v-3a8f5f1a="" class="content-wrap" :style="stemplate.sportId!='N1' ? 'width: inherit':''">
                        <template v-if="stemplate.sportId=='N1'">
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                          </div>
                        </template>
                        <template v-else>
                          <div data-v-3a8f5f1a="" style="width: inherit">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="" style="width: inherit">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="" style="width: inherit">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-3a8f5f1a="" class="item">
                  <div data-v-3a8f5f1a="" class="title">
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_50" style="width: 0.2rem; height: 0.2rem;"></div>
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.4rem; height: 0.1rem;"></div>
                  </div>
                  <div data-v-3a8f5f1a="" class="info" style="width:100%">
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                  </div>
                  <div data-v-3a8f5f1a="" class="wrap">
                    <div data-v-3a8f5f1a="" class="content" :style="stemplate.sportId!='N1' ? 'width: 100%':''">
                      <div data-v-3a8f5f1a="" class="content-wrap" :style="stemplate.sportId!='N1' ? 'width: inherit':''">
                        <template v-if="stemplate.sportId=='N1'">
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                          </div>
                        </template>
                        <template v-else>
                          <div data-v-3a8f5f1a="" style="width: inherit">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="" style="width: inherit">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="" style="width: inherit">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
                <div data-v-3a8f5f1a="" class="item">
                  <div data-v-3a8f5f1a="" class="title">
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_50" style="width: 0.2rem; height: 0.2rem;"></div>
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.4rem; height: 0.1rem;"></div>
                  </div>
                  <div data-v-3a8f5f1a="" class="info" style="width:100%">
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                    <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 50%; height: 0.1rem;"></div>
                  </div>
                  <div data-v-3a8f5f1a="" class="wrap">
                    <div data-v-3a8f5f1a="" class="content" :style="stemplate.sportId!='N1' ? 'width: 100%':''">
                      <div data-v-3a8f5f1a="" class="content-wrap" :style="stemplate.sportId!='N1' ? 'width: inherit':''">
                        <template v-if="stemplate.sportId=='N1'">
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.32rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.55rem; height: 0.49rem;"></div>
                          </div>
                        </template>
                        <template v-else>
                          <div data-v-3a8f5f1a="" style="width: inherit">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="" style="width: inherit">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                          </div>
                          <div data-v-3a8f5f1a="" style="width: inherit">
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                            <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="height: 0.49rem;"></div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div data-v-3a8f5f1a="" class="list">
              <div data-v-3a8f5f1a="" class="version_biaozhun" :style="stemplate.int_marketToggle!=2?'margin-top:0px;':''">
                <div data-v-3a8f5f1a="" class="item">
                    <div data-v-3a8f5f1a="" class="title">
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_50" style="width: 0.2rem; height: 0.2rem;"></div>
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.4rem; height: 0.1rem;"></div>
                    </div>
                    <div data-v-3a8f5f1a="" class="info">
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 3.19rem; height: 0.1rem;"></div>
                    </div>
                    <div data-v-3a8f5f1a="" class="wrap">
                      <div data-v-3a8f5f1a="" class="left">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 0.93rem; height: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.51rem; height: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.51rem; height: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.1rem; height: 0.1rem;"></div>
                      </div>
                      <div data-v-3a8f5f1a="" class="content">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.84rem; height: 0.1rem;"></div>
                          <div data-v-3a8f5f1a="" class="content-wrap">
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                            </div>
                          </div>
                      </div>
                    </div>
                </div>
                <div data-v-3a8f5f1a="" class="item">
                    <div data-v-3a8f5f1a="" class="title">
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_50" style="width: 0.2rem; height: 0.2rem;"></div>
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.4rem; height: 0.1rem;"></div>
                    </div>
                    <div data-v-3a8f5f1a="" class="info">
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 3.19rem; height: 0.1rem;"></div>
                    </div>
                    <div data-v-3a8f5f1a="" class="wrap">
                      <div data-v-3a8f5f1a="" class="left">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 0.93rem; height: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.51rem; height: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.51rem; height: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.1rem; height: 0.1rem;"></div>
                      </div>
                      <div data-v-3a8f5f1a="" class="content">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.84rem; height: 0.1rem;"></div>
                          <div data-v-3a8f5f1a="" class="content-wrap">
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                            </div>
                          </div>
                      </div>
                    </div>
                </div>
                <div data-v-3a8f5f1a="" class="item">
                    <div data-v-3a8f5f1a="" class="title">
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_50" style="width: 0.2rem; height: 0.2rem;"></div>
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.4rem; height: 0.1rem;"></div>
                    </div>
                    <div data-v-3a8f5f1a="" class="info">
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 3.19rem; height: 0.1rem;"></div>
                    </div>
                    <div data-v-3a8f5f1a="" class="wrap">
                      <div data-v-3a8f5f1a="" class="left">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 0.93rem; height: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.51rem; height: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.51rem; height: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.1rem; height: 0.1rem;"></div>
                      </div>
                      <div data-v-3a8f5f1a="" class="content">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.84rem; height: 0.1rem;"></div>
                          <div data-v-3a8f5f1a="" class="content-wrap">
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                            </div>
                          </div>
                      </div>
                    </div>
                </div>
                <div data-v-3a8f5f1a="" class="item">
                    <div data-v-3a8f5f1a="" class="title">
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_50" style="width: 0.2rem; height: 0.2rem;"></div>
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.4rem; height: 0.1rem;"></div>
                    </div>
                    <div data-v-3a8f5f1a="" class="info">
                      <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 3.19rem; height: 0.1rem;"></div>
                    </div>
                    <div data-v-3a8f5f1a="" class="wrap">
                      <div data-v-3a8f5f1a="" class="left">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 0.93rem; height: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.51rem; height: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.51rem; height: 0.1rem;"></div>
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.1rem; height: 0.1rem;"></div>
                      </div>
                      <div data-v-3a8f5f1a="" class="content">
                          <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_6" style="width: 1.84rem; height: 0.1rem;"></div>
                          <div data-v-3a8f5f1a="" class="content-wrap">
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.32rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                            </div>
                            <div data-v-3a8f5f1a="">
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                                <div data-v-eed1ea58="" data-v-3a8f5f1a="" class="skeleton radius_2" style="width: 0.6rem; height: 0.49rem;"></div>
                            </div>
                          </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div> -->
  </div>

</template>

<script>
import {
    mapGetters
} from 'vuex'
export default {
    props: {
        loading: false,
        edition: null,
        stemplate: null,
        showFavEvents: null,
    },
    data() {
        return {
          marginPX: 1,
          // heightPX : window.innerHeight,
          heightPX : 530,
        }
    },
    computed:{
        ...mapGetters([
            'account',
        ]),
    },
    methods:{
    },
    mounted() {
      this.marginPX = 1
      if(this.stemplate.int_marketToggle == "2"){
        if(this.edition == 3){
          this.marginPX = 1.35
        }else{
          this.marginPX = 1.3
        }
      }
    },
}
</script>
<style scoped>
  .spinner {
    margin: auto;
    border: 4px solid #eee;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>



// WEBPACK FOOTER //
// resources/score/vue/components/refreshScreen.vue